import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";
import { track } from "@/lib/tracking";

export default function NotFound() {
  const location = useLocation();

  useEffect(() => {
    // Log a 404 event so the admin dashboard can list broken paths.
    track("not_found", { page: location.pathname });
  }, [location.pathname]);

  return (
    <main data-testid="page-not-found" className="bg-background">
      <Seo title="Pagina niet gevonden — 404 · EquiSight" path={location.pathname} noindex />
      <Header />
      <section className="mx-auto max-w-2xl px-6 py-24 text-center">
        <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--sand-dark))]">404</p>
        <h1 className="mt-3 font-display text-5xl font-semibold text-[hsl(var(--ink))]">
          Deze pagina bestaat niet.
        </h1>
        <p className="mt-4 text-[hsl(var(--ink-soft))]">
          De link is wellicht verlopen of bevat een typfout.
        </p>
        <p className="mt-2 font-mono text-xs text-[hsl(var(--ink-soft))]">{location.pathname}</p>
        <Link
          to="/"
          data-testid="back-home-btn"
          className="mt-8 inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--forest))] px-5 py-2.5 text-sm text-[hsl(var(--background))] hover:bg-[hsl(var(--forest-dark))]"
        >
          <ArrowLeft className="h-4 w-4" /> Terug naar home
        </Link>
      </section>
      <Footer />
    </main>
  );
}
